import { render, staticRenderFns } from "./registForm.vue?vue&type=template&id=457f4750&scoped=true"
import script from "./registForm.vue?vue&type=script&lang=js"
export * from "./registForm.vue?vue&type=script&lang=js"
import style0 from "./registForm.vue?vue&type=style&index=0&id=457f4750&prod&lang=scss&scoped=true"
import style1 from "./registForm.vue?vue&type=style&index=1&id=457f4750&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f4750",
  null
  
)

export default component.exports